<div class="modal-body">
	{{confirmationMessage}}
</div>